import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Session } from 'src/app/models/session';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
})
export class NoteComponent implements OnInit {

  @Input() session : Session;
  noteForm : FormGroup

  constructor(
    private readonly apiProvider : ApiProviderService,
    private readonly userService : UserService,
    private modalCtrl : ModalController
  ) { }

  ngOnInit() {
    this.noteForm = new FormGroup(
      {
        Note : new FormControl(this.session.note)
      }
    );
  }

  cancel(){
    this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm(){
    this.session.note = this.noteForm.get("Note").value;

    this.apiProvider.editSession({ ... this.session }).subscribe(
      (session : Session) => {
        this.modalCtrl.dismiss();
      },
      (err) => {
        console.log(err);
      });
  }

  

}
